<template>
  <v-container fluid>
    <material-card v-if="reportData.length" icon="mdi-clipboard-text" inline title="Attendance report">
      <v-card-actions>
        <a @click="monthOk ? goBack() : $router.back()">
          <v-btn v-if="$vuetify.breakpoint.smAndUp" elevation="1" absolute right top> <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
          <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1" class="mr-n2 mt-10" style="opacity:.6;"> <v-icon>mdi-arrow-left</v-icon></v-btn>
        </a>
      </v-card-actions>

      <v-card-text class="pt-0 pr-1" :class="{ 'd-block py-3': $vuetify.breakpoint.xs, 'd-flex align-center': $vuetify.breakpoint.smAndUp }">
        <v-text-field
          :class="{ 'mr-0': $vuetify.breakpoint.xs, 'mr-5': $vuetify.breakpoint.smAndUp }"
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto mb-2"
          label="Search"
          hide-details
          single-line
          style="max-width:350px;"
        />
      </v-card-text>
      <v-data-table
        :footer-props="{
          'items-per-page-options': [5, 10, 20, 40]
        }"
        :items-per-page="10"
        :headers="headers"
        :items="reportData"
        :search.sync="search"
      >
        <template v-slot:item.Month="{ item }">
          <a @click="getReport(item.Month, item.year)">{{ item.Month }}</a>
        </template>
      </v-data-table>
    </material-card>
    <material-card v-if="!reportData.length" icon="mdi-clipboard-text" inline title="Attendance report">
      <v-data-table :headers="headers">
        <template v-slot:no-data>
          <v-card-subtitle class="d-flex justify-center">No Data Available</v-card-subtitle>
        </template>
      </v-data-table>
    </material-card>
    <loading-icon :value="isLoading" />
  </v-container>
</template>

<script>
import constants from '@/utils/constants'
import moment from 'moment'
import { mapGetters } from 'vuex'
import MaterialCard from '@/components/template/MaterialCard'
import _ from 'lodash'
export default {
  components: { MaterialCard },
  props: ['studentId'],
  data () {
    return {
      monthOk: false,
      franchiseeID: '',
      isLoading: false,
      reportData: [],
      search: '',
      headers: [
        { text: 'Month', value: 'Month', align: 'center', sortable: false },
        { text: 'absent', sortable: true, value: 'absent' },
        { text: 'present', sortable: true, value: 'present' },
        { text: 'Year', sortable: true, value: 'year' }
      ]
    }
  },
  created: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee'
    })
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
    },
    monthOk () {
      if (this.monthOk) {
        this.headers = [
          { text: 'date', value: 'date', align: 'center', sortable: false },
          { text: 'absent', sortable: true, value: 'absent' },
          { text: 'present', sortable: true, value: 'present' }
        ]
      } else {
        this.headers = [
          { text: 'Month', value: 'Month', align: 'center', sortable: false },
          { text: 'absent', sortable: true, value: 'absent' },
          { text: 'present', sortable: true, value: 'present' },
          { text: 'Year', sortable: true, value: 'year' }
        ]
      }
    }
  },
  methods: {
    goBack: async function () {
      this.monthOk = false
      await this.getReport()
    },
    getReport: async function (mnth, yr) {
      try {
        this.isLoading = true
        let url
        if (mnth) {
          this.monthOk = true
          let startOfMonth = moment()
            .year(yr)
            .month(mnth)
            .startOf('month')
            .format('MM/DD/YYYY')
          let endOfMonth = moment()
            .year(yr)
            .month(mnth)
            .endOf('month')
            .format('MM/DD/YYYY')

          url = `${constants.API_URL}/api/attendance/student/count?franchiseeID=${this.franchiseeID}&&studentAdmissionsID=${this.studentId}&&isMonth=false&&fromDate=${startOfMonth}&&toDate=${endOfMonth}`
          let res = await http.get(url)
          this.reportData = res.data && res.data.attendanceRecords ? res.data.attendanceRecords : []
          this.reportData = _.sortBy(this.reportData, 'date').reverse()
        } else {
          url = `${constants.API_URL}/api/attendance/student/count?franchiseeID=${this.franchiseeID}&&studentAdmissionsID=${this.studentId}`
          let res = await http.get(url)
          this.reportData = res.data && res.data.attendanceRecords ? res.data.attendanceRecords : []
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.studentId) {
          await this.getReport()
        }
        this.inProgress = false
      }
    },
    okMsg (msg) {
      return this.$buefy.dialog.alert({
        type: 'is-success',
        message: msg,
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
